import React from 'react';
import { Button } from "@mui/material";


export const PrimaryButton = ({ label }) => {
    <Button variant='contained' sx={{ backgroundColor: '#0044C6' }}>
        {label}
    </Button>
}

export const SecondaryButton = ({ label }) => {
    <Button sx={{ color: '#0044C6' }}>
        {label}
    </Button>
}

export const CustomButton = ({ label, bgColor, color, sx = {}, image, handleOnClick }) => {
    return (
        <Button className="d-flex flex-column py-1 px-5" sx={{
            backgroundColor: bgColor, color: color,
            '&:hover': {
                border: "1px solid rgba(0,82,204,0.2)",
                cursor: "pointer",
                
                // color:"#ffffff"
            },
            textTransform: 'none',
            ...sx
        }} onClick={() => handleOnClick()}>
            <img src={image} alt='Image' className='my-1' />
            {label}
        </Button>
    );

}